import React from 'react';
import {Dropdown, Icon, IconButton, IDropdownOption, Label, TooltipHost, IRenderFunction, ISelectableOption} from '@fluentui/react';
import MarkdownView from "react-showdown";
import {SettingId} from "../../settings/registry";

interface IDropdownFieldProps {
    disabled?: boolean;
    label?: string;
    labelActions?: React.ReactNode;
    options: IDropdownOption[];
    onChange?: ((event: React.FormEvent<HTMLDivElement>, option?: (IDropdownOption<any> | undefined), index?: (number | undefined)) => void) | undefined
    toolTip?: string;
    selectedKey?: string | number | string[] | undefined;
    selectedKeys?: string[] | number[],
    required?: boolean;
    placeholder?: string;
    statusIcon?: string;
    statusMessage?: string;
    multiSelect?: boolean;
    prefixIconName?: string;
    onPrefixClick?: () => void;
    prefixTooltip?: string;
    /** Registry identifier, so documentation can deep-link to this field. */
    settingId?: SettingId;
    /** Fluent Dropdown render hooks, for options that need more than text (e.g. a storefront favicon). */
    onRenderOption?: IRenderFunction<ISelectableOption>;
    onRenderTitle?: IRenderFunction<IDropdownOption[]>;
}


const DropdownField: React.FC<IDropdownFieldProps> = (props) => {

    const label = () => {
        if (props.toolTip) {
            return (<TooltipHost content={<MarkdownView markdown={props.toolTip}/>}>
                <div style={{display: "inline-flex"}}>
                    <Label required={props.required}>
                        <Icon iconName={'Info'} style={{paddingRight: '5px'}}/>{props.label}
                        {props.labelActions}
                    </Label>
                </div>
            </TooltipHost>)
        }
        return (
            <div style={{display: "inline-flex"}}>
                <Label required={props.required}>{props.label}</Label>
                {props.labelActions}
            </div>)
    }
    return (<div data-setting-id={props.settingId}>
        {props.label && label()}
        <div style={{display: "inline-flex", width: "100%", alignItems: 'center'}}>
            {props.prefixIconName && (
                <TooltipHost content={props.prefixTooltip}>
                    <IconButton
                        iconProps={{iconName: props.prefixIconName}}
                        onClick={props.onPrefixClick}
                        styles={{root: {flexShrink: 0}}}
                    />
                </TooltipHost>
            )}
            <Dropdown
                multiSelect={props.multiSelect}
                selectedKeys={props.selectedKeys}
                placeholder={props.placeholder}
                required={props.required}
                disabled={props.disabled}
                options={props.options}
                onChange={props.onChange}
                selectedKey={props.selectedKey}
                onRenderOption={props.onRenderOption}
                onRenderTitle={props.onRenderTitle}
            />
            {props.statusIcon &&
                <TooltipHost content={props.statusMessage}>
                    <Icon iconName={props.statusIcon}/>
                </TooltipHost>
            }
        </div>
    </div>)
}

export default DropdownField;